jQuery(document).ready(function ($) {
    const checkMenuHeight = (e) => {
        const menuItem = $(e.currentTarget);
        const subMenus = $('.sub-menu', menuItem);

        if (subMenus.length === 0) {
            return;
        }

        const submenuHeights = subMenus.map((i, menu) => $(menu).outerHeight(true));

        menuItem[0].style.setProperty('--submenu-height', `${Math.ceil(Math.max.apply(Math, submenuHeights))}px`);
    };

    $(document).on('mousemove', '.menu > .menu-item', (e) => {
        window.requestAnimationFrame(() => checkMenuHeight(e));
    });
})